<template>
  <div>
    <el-dialog :visible.sync="diaShow" title="批量导入发货" width="650px" custom-class="dialog-body-paddingTop-10" @close="close" v-loading="importExtendLoading">
      <div class="yellowBox flex flex-align-center">
				请下载导入发货模板，根据文件中的填写须知，按要求完善数据再导入
				<el-button @click="getFileOriginal" class="margin-left-20">下载模板</el-button>
			</div>
			<div v-if="extendFile.IsExistProgress" class="file-box">
				<div class="flex flex-align-center flex-column" v-if="!extendFile.IsComplete">
					<div class="flex flex-align-center">
						<img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/melyshop/image/exce-distributionInquiry20240513.png" style="width:30px" alt="">
						<div class="margin-left-20 margin-right-20 loading">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
						<img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/melyshop/image/XT-qidian.png" style="width:30px" alt="">
					</div>
					<div style="text-align:center">
						<div class="color-606266 margin-top-20">数据导入中...</div>
						<div class="color-999999 margin-top-10">导入需要一定时间，请勿关闭操作框</div>
					</div>
				</div>
				<div style="text-align:center" v-else>
					<div class="color-606266">导入完成</div>
					<div class="color-999999 margin-top-10">成功导入{{extendFile.SuccessCount}}条，失败{{extendFile.FailCount}}条<span v-if="extendFile.FailCount">，可下载导入失败数据</span></div>
					<el-button class="margin-top-20" v-if="extendFile.FailCount>0" @click="getresult(extendFile.importId,true)">下载导入失败数据</el-button>
				</div>
			</div>
			<el-upload :action="uploadFile" accept=".xls,.xlsx" class="file-box" :show-file-list="false" :before-upload="beforeUpload"
				 :on-success="handleUploadSuccess" v-else>
				<div v-if="extendFile.filePath" class="color-999999">
					<i class="el-icon-document"></i>
					<div class="margin-top-10 margin-bottom-20">{{extendFile.fileName}}</div>
				</div>
				<div v-else class="color-999999">
					<div>
						点击按钮上传文件，
					</div>
					<div class="margin-top-10 margin-bottom-10">
						支持xls、xlsx格式
					</div>
				</div>
				<el-button>上传文件</el-button>
			</el-upload>
			<div style="text-align:center" class="margin-top-30">
				<el-button type="primary" style="width:300px" v-if="hasConfirmBtn" @click="confirmImport">确认导入</el-button>
			</div>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/config/index';
import {
  cittaDistributionOrderimportSendInProgress,
  cittaDistributionOrderimportSend,
} from "@/api/sv3.0.0"
import axios from 'axios'
export default {
  props:{
    show:{
      type:Boolean,
      default:false,
    }
  },
  watch:{
    show(val){
      this.diaShow = val
      this.inquire()
    }
  },
  data () {
    return {
      diaShow:false,
      uploadFile: config.UPLOAD_ZIP,
      extendFile: {
        filePath:'',
        fileName:'',
        importId:0,
        SuccessCount:0,
        FailCount:0,
        IsComplete:false,
        IsExistProgress:false,
      },
      hasConfirmBtn: false,
      importExtendLoading: false,
      timeOut: null
    }
  },
  methods: {
    getFileOriginal(){
      let url = `https://cdn.dkycn.cn/${encodeURIComponent('西苔分销商订单批量导入发货模板')}.xlsx`
      window.open(url)
    },
    async getresult(RecordId,IsExport){
      try{
				let res = await axios.get('/pc/cittaDistributionOrder/importSendResultExport'+`?RecordId=${RecordId}&IsExport=${IsExport}`,{
					responseType:IsExport?'blob':undefined,
				})
				if(!IsExport){
					if(res.data.IsSuccess){
            // res.data.Result = {
            //   IsDealFinish:true,
            //   FailCount:1,
            //   SuccessCount:2
            // }
						if(!res.data.Result.IsDealFinish){
							setTimeout(()=>{
								this.getresult(RecordId,false)
							},500)
						}else{
              this.extendFile.IsComplete = true
              this.extendFile.FailCount = res.data.Result.FailCount
              this.extendFile.SuccessCount = res.data.Result.SuccessCount
						}
					}else{
						this.$message.error(res.data.Message)
            this.extendFile.IsExistProgress = false
					}
				}else{
					let blob = new Blob([res.data],{type:"application/octet-stream; charset=utf-8"})
					let a = document.createElement('a')
					a.style.display = 'none'
					a.download = `导入失败数据.xlsx`
					a.href = URL.createObjectURL(blob)
					a.click()
					a.remove()
				}
			}finally{
				//
			}
    },
    async confirmImport(){
      try{
        this.importExtendLoading = true
        let res = await cittaDistributionOrderimportSend({
          ExcelFilePath:this.extendFile.filePath,
          ExcelFileName:this.extendFile.fileName,
        })
        if(res.IsSuccess){
          this.extendFile.importId = res.Result.RecordId
          this.extendFile.IsExistProgress = true
          this.hasConfirmBtn = false
          this.getresult(res.Result.RecordId,false)
        }
      }finally{
        this.importExtendLoading = false
      }
    },
    async inquire(){
      try{
        this.importExtendLoading = true
        let res = await cittaDistributionOrderimportSendInProgress()
        if(res.IsSuccess){
          if(res.Result.IsInProgress){
            this.extendFile.importId = res.Result.RecordId
            this.extendFile.IsExistProgress = true
            this.getresult(res.Result.RecordId,false)
          }else{
            for(let key in res.Result){
              this.extendFile[key] = res.Result[key]
            }
          }
        }
      }finally{
        this.importExtendLoading = false
      }
    },
    handleUploadSuccess(file){
      this.extendFile.filePath = file[0]
      this.hasConfirmBtn = true
    },
    beforeUpload(file){
      var type = file.name.split('.')[file.name.split('.').length-1];
      if (['xls', 'xlsx'].indexOf(type) > -1){
        this.extendFile.fileName = file.name;
        return true;
      }else{
        this.$message.error('请选择正确的文件上传')
        return false;
      }
    },
    close(e){
      this.extendFile = {
        filePath:'',
        fileName:'',
        importId:0,
        SuccessCount:0,
        FailCount:0,
        IsComplete:false,
        IsExistProgress:false,
      }
      this.hasConfirmBtn = false;
      clearTimeout(this.timeOut)
      this.$emit('close',false)
    }
  }
}
</script>

<style lang='less' scoped>

.yellowBox{
	background: #FDF6EC;
	padding: 15px ;
	font-size: 14px;
	color: #FDA23C;
}
.file-box{
	border: 1px solid #DCDFE6;
	width: 500px;
	height: 172px;
	margin: 20px auto;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>